import { appDefaults } from "common/themes/default.theme";

const sidebarStyle = (theme) => {
  const { sidebarWidth, headerHeight, footerHeight } = appDefaults;

  return {
    sidebar: {
      height: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(1.5, 3),
      borderTop: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up("sm")]: {
        padding: 0,
        borderTop: "none",
        flexDirection: "column",
      },
    },
    content: {
      height: `calc(100% - ${headerHeight}px)`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    menu: {
      display: "inline-flex",
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    drawerPaper: {
      overflowX: "hidden",
      zIndex: 1,
    },
    drawerAnchorLeft: {
      maxWidth: sidebarWidth,
    },
    logoContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: headerHeight,
      margin: theme.spacing(0, 1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
      "&>img": {
        height: "100%",
        width: "100%",
      },
    },
    nav: {
      width: "100%",
      height: "100%",
      "& div.MuiListItemIcon-root": {
        justifyContent: "center",
      },
      [theme.breakpoints.up("sm")]: {
        height: `calc(100% - ${headerHeight}px - ${footerHeight}px)`,
        "& div.MuiListItem-root": {
          flexFlow: "column nowrap",
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4),
          "& span": {
            fontSize: theme.typography.pxToRem(8),
          },
        },
      },
    },
    link: {
      color: theme.palette.text.primary,
      textDecoration: "none",
    },
    menuText: {
      textAlign: "center",
    },
    active: {
      color: theme.palette.primary.main,
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
    profile: {
      cursor: "pointer",
      padding: theme.spacing(2),
      zIndex: 2,
    },
    toolbar: {
      justifyContent: "space-between",
    },
  };
};

export default sidebarStyle;
